import http from './http'

class Operation {
  create (payload) {
    return http.post('/operations', payload)
  }

  forceRequest (payload) {
    return http.put(`/operations/${payload.id}/force_send_assignment_request`)
  }

  cancelRequest (id) {
    return http.put(`/operations/${id}/cancel`)
  }

  acceptRequest (id) {
    return http.put(`/operations/${id}/accept`)
  }

  cancelManyRequest (ids) {
    return http.put(`/operations/cancel_many`, { assignment_request_ids: ids })
  }

  acceptManyRequest (ids) {
    return http.put(`/operations/accept_many`, { assignment_request_ids: ids })
  }
}

export default new Operation()



// WEBPACK FOOTER //
// ./src/services/operation.js